const RECENTLY_VIEWED_GLOBAL_SEARCH = 'RECENTLY_VIEWED_GLOBAL_SEARCH';
const defaultObjectKeys = ['students', 'bookings', 'nominationPlans'];
const currentVersion = '0.0.2';

// lastVersion: 0.0.2
export const recentlyViewedDefaultData = {
  students: [],
  bookings: [],
  nominationPlans: [],
  version: currentVersion,
};

const getSimpleItem = (type, data) => {
  if (type === 'bookings') {
    const { id, student, roomAllocation, status, tenancyOption, category, property } = data;
    return {
      id,
      student,
      roomAllocation,
      status,
      tenancyOption,
      category,
      property,
    };
  }

  if (type === 'students') {
    const { id, gender, fullName, profilePhotoFileUuid } = data;
    return {
      id,
      gender,
      fullName,
      profilePhotoFileUuid,
    };
  }

  if (type === 'nominationPlans') {
    const { name, academicYear, endDate, id, originId, property, startDate } = data || {};
    return {
      name,
      endDate,
      nominationPlanId: id,
      originId,
      propertyName: property?.name,
      startDate,
      academicYearName: academicYear?.name,
      academicYearId: academicYear?.id,
      propertyId: property?.id,
    };
  }
};

export const formateLocalStorage = (type, item) => {
  if (!defaultObjectKeys.includes(type)) return false;

  let recentlyViewed = JSON.parse(
    getGlobalSearchResultLocalStorage() || JSON.stringify(recentlyViewedDefaultData)
  );

  const removeMultiplyIndex = recentlyViewed[type].findIndex((viewed) => item?.id === viewed?.id);
  if (removeMultiplyIndex !== -1) recentlyViewed[type].splice(removeMultiplyIndex, 1);

  // remove more than 4
  if (recentlyViewed[type].length > 4) recentlyViewed[type].splice(4, 1);

  if (recentlyViewed[type].length > 0) recentlyViewed[type].unshift(getSimpleItem(type, item));
  if (recentlyViewed[type].length === 0) recentlyViewed[type] = [getSimpleItem(type, item)];
  return recentlyViewed;
};

export const setGlobalSearchResultLocalStorage = (type, setItemData) => {
  const setItemsData = formateLocalStorage(type, setItemData);

  window.localStorage.setItem(RECENTLY_VIEWED_GLOBAL_SEARCH, JSON.stringify(setItemsData));
};

export const getGlobalSearchResultLocalStorage = () => {
  const localStorageData = window.localStorage.getItem(RECENTLY_VIEWED_GLOBAL_SEARCH);
  if (localStorageData && JSON.parse(localStorageData).version !== currentVersion) {
    return localStorage.removeItem('RECENTLY_VIEWED_GLOBAL_SEARCH');
  }

  if (!localStorageData) {
    window.localStorage.setItem(
      RECENTLY_VIEWED_GLOBAL_SEARCH,
      JSON.stringify(recentlyViewedDefaultData)
    );
  }
  return window.localStorage.getItem(RECENTLY_VIEWED_GLOBAL_SEARCH);
};
